import React from 'react';
import { connect } from 'react-redux';
import appHistory from 'components/common/appHistory';

import { setAPIKey, clearToken } from 'actions/authentication';
import { setCurrentNode, fetchCustomerOverview } from 'actions/overview';
import './style/main.less';
import { fetchCard } from 'actions/defaultsettings';
import { fetchLiveData } from 'actions/node';
import { fetchImage } from 'actions/floorplan';
import { fetchCurrentUser } from 'actions/myaccount';
import { fetchConfig } from 'actions/devicemanagement';
import Loading from 'components/common/Loading';
import ToolBar from 'containers/toolbar';
import ScrollTop from 'components/common/scrolltop';

export class Frame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardLoaded: false,
            treeLoaded: false,
            liveLoaded: false,
            imageLoaded: false,
            configLoaded: false
        }
    }


    handleTreeClick(node) {
        if (this.props.location.pathname.includes("/statistic") || this.props.location.pathname == "/" ||
            this.props.location.pathname.includes("/comparison") || this.props.location.pathname.includes("/settings/sensor")) {
            appHistory.push(`/statistic/${node.id}`);
        } else if (this.props.location.pathname.includes("/live")) {
            appHistory.push(`/live/${node.id}`);
        } else if (this.props.location.pathname.includes("/heatmap")) {
            appHistory.push(`/heatmap/${node.id}`);
        } else {
            this.props.dispatch(setCurrentNode(node));
        }
    }

    componentDidMount() {
        var chain = () => this.props.dispatch(fetchCurrentUser()).then((res) => {
            console.log("res", res)
            this.props.dispatch(fetchCard()).then(() => this.setState({ cardLoaded: true }));
            this.props.dispatch(fetchCustomerOverview()).then(() => this.setState({ treeLoaded: true }));
            this.props.dispatch(fetchLiveData()).then(() => this.setState({ liveLoaded: true }));
            this.props.dispatch(fetchImage()).then(() => this.setState({ imageLoaded: true }));
            this.props.dispatch(fetchConfig());
        }).catch((err) => {
            console.log(err)
        });

        console.log(this.props.location.query);
        if (this.props.apikey != this.props.location.query["apikey"]) {
            this.props.dispatch(setAPIKey(this.props.location.query["apikey"])).then(() => chain());
        } else {
            chain();
        }

    }

    render() {
        // return (!this.props.loading && this.props.user && this.props.tree && this.props.cards && this.props.sensorMap && this.props.images) ?
        return (
            this.state.cardLoaded && this.state.treeLoaded && this.state.liveLoaded && this.state.imageLoaded &&
            this.props.user && this.props.tree && this.props.cards && this.props.sensorMap && this.props.images) ?

            <div className="app_container">
                <ToolBar
                    actions={{ logout: this.props.logout }}
                    statistic={this.handleTreeClick.bind(this)}
                    location={this.props.location}
                />
                <div className="app__content">
                    {this.props.children}
                    <ScrollTop></ScrollTop>
                </div>
            </div>
            : <Loading />
    }
}

function mapStateToProps(state) {
    return {
        user: state.myAccountReducer.user,
        apikey: state.myAccountReducer.apikey,
        tree: state.overviewReducer.customerOverview,
        cards: state.defaultSettingsReducer.card,
        sensorMap: state.nodeReducer.map,
        images: state.floorPlanReducer.images
    }
}

function mapDispatchToProps(dispatch) {
    return {
        logout: () => {
            dispatch(clearToken());
        },
        setCurrentNode: (node) => {
            dispatch(setCurrentNode(node));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Frame);



// WEBPACK FOOTER //
// ./src/frame.jsx